import { useEffect, useState } from 'react';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

type UseAutoTurnOnCampaignProps = {
  flightPromoCodes: Set<string> | undefined;
  isCampaignAvailable: boolean;
};

// As soon as campaign flights become available, we want to turn off the
// `noCampaign` flag, and indicate that the last search caused this switch.
const useAutoTurnOnCampaign = ({
  flightPromoCodes,
  isCampaignAvailable,
}: UseAutoTurnOnCampaignProps) => {
  const [
    lastSearchCausedSwitchToCampaignOptions,
    setLastSearchCausedSwitchToCampaignOptions,
  ] = useState(false);
  const { searchQuery, setSearchQuery } = useSearchQuery();
  const { noCampaign } = searchQuery || {};

  // turn flag off on new search
  useEffect(() => {
    setLastSearchCausedSwitchToCampaignOptions(false);
  }, [flightPromoCodes]);

  // Automatically resets to show campaign package options once they become
  // available. Also update flag to indicate the search caused a switch back
  // to show campaigns options.
  useEffect(() => {
    if (isCampaignAvailable && flightPromoCodes && noCampaign) {
      setSearchQuery({ noCampaign: undefined });
      setLastSearchCausedSwitchToCampaignOptions(true);
    }
  }, [flightPromoCodes, isCampaignAvailable, noCampaign, setSearchQuery]);

  /** Flag to indicate if the latest search triggered an auto switch from showing
   * non-campaign (Holidays Exclusive) options to campaign options*/
  return lastSearchCausedSwitchToCampaignOptions;
};

export default useAutoTurnOnCampaign;
